import { PersonalDetailsState, RootState } from '@/store';

export const getPersonalDetails = (state: RootState): PersonalDetailsState => state.personalDetails;
